import * as types from "../actions/actionTypes";

const initialModalData = { title: "", message: "" };
const initialState = {
  modalStatus: false,
  modalData: initialModalData
};

const PanelSelection = (state = initialState, action) => {
  switch (action.type) {
    case types.PANEL_SELECTION_MODAL_DATA:
      return { ...state, modalStatus: true, modalData: action.data };
    case types.PANEL_SELECTION_CLOSE_MODAL:
      return { ...state, modalStatus: false, modalData: initialModalData };
    default:
      return state;
  }
};

export default PanelSelection;
